import { useEffect, useState } from "react"
import { fetchData, GENERATE_FILE_TOKEN } from "../../components/Service"

function FileMananger() {
    const [token, setToken] = useState(false)

    useEffect(() => {
        fetchData(GENERATE_FILE_TOKEN, 'POST', '', true, false, (res) => {
            if (res.records) {
                setToken(res.records)
            }
        })
    }, [])

    return (
        <>
            <div className="container-fluid">
                <div className="page-head sticky_top_padding">
                    <div className="row g-2 align-items-center">
                        <div className="col-lg-6 col-6 mb-3">
                            <h1 className="h3 text-dim mb-0">File Manager</h1>
                        </div>
                    </div>
                </div>
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-1">
                    {token && <iframe src={process.env.REACT_APP_ENDPOINT + "/file-manager/" + token} style={{ height: "85vh", width: "100%" }} title="Drive"></iframe>}
                </div>
            </div>
        </>
    )
}

export default FileMananger